import React from "react";
import Dialog from "@material-ui/core/Dialog";
import clsx from "clsx";
import useStyles from "./styles";

const CustomPopup = ({
  open,
  action1,
  action2,
  heading,
  bodyMsg,
  btnText1,
  btnText2,
  icon,
  action1ClassName,
  doneIcon,
  wrapperPadding,
}) => {
  const classes = useStyles();

  return (
    <Dialog open={open}>
      <div className={clsx(classes.confirmDialogWrapper, wrapperPadding)}>
        <div className={classes.popupContent}>
          {icon && <div className={clsx(classes.icon, doneIcon)}>{icon}</div>}

          {heading && <h4 className={classes.baseColor}>{heading}</h4>}

          <p>{bodyMsg}</p>
        </div>

        <div className={classes.btnContainer}>
          {btnText2 && (
            <span
              onClick={(event) => action2(event, true)}
              className={classes.confirmButton}
              variant="contained"
            >
              {btnText2}
            </span>
          )}

          {btnText1 && (
            <span
              onClick={(event) => action1(event, true)}
              className={clsx(
                classes.confirmButton,
                classes.greenText,
                action1ClassName
              )}
              variant="contained"
            >
              {btnText1}
            </span>
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default CustomPopup;
